import { Store } from '@ngrx/store';
import { BaseContainer } from '../../base/BaseContainer';
import * as fromRoot from '../../../core/store';
import { Definitions } from '../../../core/store/definitions/definitions.interface';
import { FlordersFilter } from '../../../core/interfaces/florders-filter.interface';
import { util } from '../../../core/util/util';
import { Definition } from '../../../core/store/definitions/definition.interface';
import { takeWhile } from 'rxjs/operators';
import { Directive } from '@angular/core';

@Directive()
export abstract class FlorderPageContainer extends BaseContainer {
  definitions: Definitions;
  filter: FlordersFilter;
  totalItems: number;
  filterExcecutionTimestamp: Date;
  ordersAreLoading: boolean = false;
  isDownloading: boolean = false;
  shipTos: Definition[];

  constructor() {
    super();
    this.store
      .select('definitions')
      .pipe(takeWhile(() => !this.destroyed))
      .subscribe((definitions: Definitions) => (this.definitions = definitions));
  }

  filterFlorders({ value, valid }: { value: FlordersFilter; valid: boolean }) {
    if (valid) {
      this.filterExcecutionTimestamp = new Date();
      this.filter = util.deepCopy(value);
      this.filter.pageNr = 1;
      this.reload(true);
    }
  }

  onPageChange(pageNr): void {
    this.filter.pageNr = pageNr;
    this.reload(false);
  }

  onItemsPerPageChange(itemsPerPage: number) {
    this.filter.pageSize = itemsPerPage;
    this.reload(false);
  }

  protected abstract reload(isNew: boolean);

  protected abstract createFlorder();

  abstract resetFilter();

  sortChange({ sortField, sortAscending }) {
    this.filter.sortField = sortField;
    this.filter.sortAscending = sortAscending;
    this.reload(false);
  }
}
